<template>
    <div class="h-full absolute left-0 top-3 z-50"  v-cloak>
        <span
            class="flex items-center bg-blas-300 cursor-pointer p-3 rounded-r-lg"
            v-on:click="isOpen = !isOpen"
            v-if="!isOpen"
            id="search-icon"
        >
            <svg xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 cursor-stroke text-white"
                viewBox="0 0 40 40">
                <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                    <path d="M23.41,20.59,18.77,16a10.25,10.25,0,1,0-8.52,4.56,10.14,10.14,0,0,0,5.69-1.74l4.65,4.65a2,2,0,0,0,2.82,0A2,2,0,0,0,23.41,20.59ZM10.25,3A7.25,7.25,0,1,1,3,10.26,7.26,7.26,0,0,1,10.25,3Z" style="fill: #000000"></path>
                </g>
            </svg>
        </span>

        <div v-cloak
            id="search-container"
            class="w-[320px] sm:w-[500px] overflow-y-auto absolute top-0 z-50 rounded-r-lg shadow-lg p-7 bg-white transition-all ease-in duration-400"
            :class="{'left-0' : isOpen, '-left-[500px]' : !isOpen}"
        >
            <span class="absolute top-3 right-5 cursor-pointer"
                v-on:click="isOpen = false"
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                class="current-stroke w-2 h-2 text-blas-500/50"
                    viewBox="0 0 40 40" >
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path class="st0" d="M4.5,12c0-0.7,0.3-1.3,0.8-1.7l11.2-9.8c0.8-0.7,1.9-0.6,2.6,0.2c0.6,0.8,0.6,1.9-0.2,2.5l-9.8,8.6
	C9,11.9,9,12,9.1,12.1c0,0,0,0,0,0l9.8,8.6c0.8,0.7,0.9,1.8,0.2,2.6c-0.7,0.8-1.8,0.9-2.6,0.2c0,0,0,0-0.1-0.1L5.3,13.7
	C4.8,13.3,4.5,12.6,4.5,12z">
                        </path>
                    </g>
                </svg>
            </span>

            <h2 class="text-center text-lg text-gray-500">
                Full list of winners and finalists
            </h2>

            <h3 class="text-center font-light text-base text-gray-400 mb-1.5">
                Search by product or producer
            </h3>

            <div class="text-center mb-1.5">
                <label for="list-view" class="inline-flex items-center text-gray-500">
                    <input
                        type="radio"
                        id="list-view"
                        v-model="view"
                        value="table"
                        class="mr-1 shadow accent-gray-600"
                    />
                    List view
                </label>

                <label for="table-view" class="inline-flex items-center text-gray-500 ml-3">
                    <input
                        type="radio"
                        id="table-view"
                        v-model="view"
                        value="map"
                        class="mr-1 shadow accent-gray-600"
                    />
                    Map view
                </label>
            </div>

            <div class="flex items-center justify-between px-2.5 py-2 rounded-lg  border border-blas-500"
                :class="{ 'bg-white' : hasSearch, 'bg-blas-500/50' : !hasSearch }"
                >
                <input
                    type="text"
                    name="search"
                    v-model="search.s"
                    class="grow bg-transparent outline-none border-0 placeholder:text-white/75 placeholder:font-light text-xs"
                    :class="{ 'text-black' : hasSearch, 'font-bold' : hasSearch, 'font-light' : !hasSearch }"
                    placeholder="What are you looking for, product name, producer, location?"
                    >

                <span class="text-xs cursor-pointer font-light"
                    :class="{ '!text-black' : hasSearch, 'text-white/75' : !hasSearch }"
                >
                    Search
                </span>
            </div>

            <div class="border border-blas-500 bg-gray-300 text-white shadow mt-5 rounded text-center ">
                <input
                    type="submit"
                    class="w-full h-full border-0 text-lg font-medium py-0.5"
                    value="Submit"
                    v-on:click.prevent="isOpen = false"
                />
            </div>

            <h3 class="text-center mt-7 font-medium text-blas-400">Advanced Search</h3>

            <div class="border border-blas-300 shadow mt-2.5 rounded pt-6 pb-8 px-3.5">
                <h3 class="font-medium text-blas-400 pb-2.5">Categories</h3>

                <div class="flex items-center justify-between flex-wrap">

                    <label for="key-awards" class="flex items-center">
                        <input
                            type="checkbox"
                            id="key-awards"
                            value="key-awards"
                            class="accent-gray-600"
                            v-model="search.key_awards"
                        />
                        <span class="ml-2 font-light text-blas-400">Key Awards</span>
                    </label>

                    <label for="chefs-larder" class="flex items-center">
                        <input
                            type="checkbox"
                            id="chefs-larder"
                            value="chefs-larder"
                            class="accent-gray-600"
                            v-model="search.key_awards"
                        />
                        <span class="ml-2 font-light text-blas-400">Chef's Larder</span>
                    </label>

                    <label for="best-in-county" class="flex items-center">
                        <input
                            type="checkbox"
                            id="best-in-county"
                            value="best-in-county"
                            class="accent-gray-600"
                            v-model="search.key_awards"
                        />
                        <span class="ml-2 font-light text-blas-400">Best in County</span>
                    </label>
                </div>

            </div>

            <div class="border border-blas-300 shadow mt-5 rounded pt-6 pb-8 px-3.5">
                <h3 class="font-medium text-blas-400 pb-2.5">Award grade</h3>

                <div class="flex items-center justify-between flex-wrap">
                    <label for="gold" class="flex items-center">
                        <input
                            type="checkbox"
                            id="gold"
                            value="Gold"
                            class="accent-gray-600"
                            v-model="search.grade"
                        />
                        <span class="ml-2 font-light text-blas-400">Gold</span>
                    </label>

                    <label for="silver" class="flex items-center">
                        <input
                            type="checkbox"
                            id="silver"
                            value="Silver"
                            class="accent-gray-600"
                            v-model="search.grade"
                        />
                        <span class="ml-2 font-light text-blas-400">Silver</span>
                    </label>

                    <label for="bronze" class="flex items-center">
                        <input
                            type="checkbox"
                            id="bronze"
                            value="Bronze"
                            class="accent-gray-600"
                            v-model="search.grade"
                        />
                        <span class="ml-2 font-light text-blas-400">Bronze</span>
                    </label>

                    <label for="finalist" class="flex items-center">
                        <input
                            type="checkbox"
                            id="finalist"
                            value="Finalist"
                            class="accent-gray-600"
                            v-model="search.grade"
                        />
                        <span class="ml-2 font-light text-blas-400">Finalist</span>
                    </label>
                </div>

            </div>

            <div class="flex items-stretch flex-col md:flex-row justify-between mt-5">
                <div class="border border-blas-300 shadow rounded pt-6 pb-8 px-3.5 w-full md:w-1/2 mr-2.5">
                    <label for="county" class="block font-medium text-blas-400 pb-2.5">County</label>

                    <select id="county"
                        name="county"
                        v-model="search.county"
                        class="w-full border border-blas-400 rounded px-1 py-0.5 font-light text-blas-400 text-sm">
                        <option value="all">Select All</option>
                        <option v-for="county in countiesObj" :key="county.id" :value="county">{{ county }}</option>
                    </select>
                </div>

                <div class="border border-blas-300 shadow rounded pt-6 pb-8 px-3.5 w-full md:w-1/2 mt-5 md:mt-0">
                    <label for="distance" class="block font-medium text-blas-400 pb-2.5">Distance from me (km)</label>
                    <input type="text"
                        id="distance"
                        name="distance"
                        v-model="search.distance"
                        class="w-24 border border-blas-400 rounded px-1 py-0.5 font-light text-blas-400 text-sm"
                        placeholder="Distance"
                        />
                    <span class="ml-2 font-light text-blas-400 text-sm">KM</span>
                </div>

            </div>

            <div class="border border-blas-300 shadow mt-5 rounded pt-6 pb-8 px-3.5">
                <label for="award-category" class="block font-medium text-blas-400 pb-2.5">Category of award</label>

                <select id="award-category"
                    name="award-category"
                    v-model="search.award_category"
                    class="w-full border border-blas-400 rounded px-1 py-0.5 font-light text-blas-400 text-sm">
                    <option value="all">All</option>
                    <option v-for="(category, index) in categoriesObj" :key="index" :value="index">{{ category }}</option>
                </select>

            </div>

            <div class="border border-blas-500 bg-gray-300 text-white shadow mt-5 rounded text-center ">
                <input
                    type="submit"
                    class="w-full h-full border-0 text-lg font-medium py-0.5"
                    value="Submit"
                    v-on:click.prevent="isOpen = false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            isOpen: false,
            countiesObj : [],
            categoriesObj : [],
        }
    },
    mounted() {
        this.countiesObj = JSON.parse(this.counties);
        this.categoriesObj = JSON.parse(this.categories);

        if (localStorage.getItem('blasSearch') === null) {
            this.search.county = 'all';
            this.search.award_category = 'all';
        }

        this.setSearchHeight();

        if (window.screen.width >= 640) {
            this.isOpen = true;
        }
    },
   created() {
        /**
         * Setup the app
         */

        window.addEventListener("resize", this.setSearchHeight);
    },
    destroyed() {
        window.removeEventListener("resize", this.setSearchHeight);
    },
    computed : {
        hasSearch() {
            if (this.search?.s?.length > 0) {
                return true;
            }

            return false;
        }
    },
    watch: {
        view(newView) {
            this.$emit('changeView', newView);
        },
        search : {
            handler(newSearch){
                this.handleSearch(newSearch);
            },
            deep: true
        },
        isOpen(newValue) {
            this.$emit('sideBarToggle', newValue);
        },
        openModal(newValue) {
            if (newValue) {
                this.isOpen = false;
            }
        }
    },
    props : {
        view : {
            type: String,
            default: 'map'
        },
        search : {
            type: Object,
            default: {
                key_awards: [],
                grade: [],
            }
        },
        openModal : {
            type: Boolean,
            default: false
        },
        categories : {
            type: String,
            default: ''
        },
        counties : {
            type: String,
            default: ''
        },
        mapContainer: {
            type: Object
        }
    },
    methods : {
        handleSearch: _.debounce(function (newSearch) {
            this.$emit('completeSearch', newSearch);
        }, 500),
        setSearchHeight() {
            //calculate the height of the search box
            let appHeight = window.innerHeight;
            let header = this.$parent.$parent.$refs.header.clientHeight;
            let footer = this.$parent.$parent.$refs.footer.clientHeight;
            let height = appHeight - (header + footer);
            let container = document.getElementById('search-container');
            container.style.height = (height - 30) + 'px';
        }
    }
}

</script>
